import { httpUtil } from './httpUtil';

const querystring = require('querystring');

let urlPlugins = document._portalConfig.urlPlugins;
let api_key = document._portalConfig.apiKeyPlugins;
let urlPaygate = document._portalConfig.urlPaygate;
let apiKeyPaygate = document._portalConfig.apiKeyPaygate;

export const etvservices = {
    getSubscriptionsContact,
    getDevicesSerialNumber,
    onAddDevice,
    onReAuth,
    onCancelSubscription,
    onGetCustomers,
    onMergeContact,
    requestOTP,
    verifyOTP,
    onEnableDevice,
    getSubscriptionAction,
    initPayment,
    createPayment,
    onUpdateDeviceName,
    getContactService,
    onAddDeivce,
    onGetDevices,
    onMakeOrder,
    onEstimateOrder,
    onDeactiveService,
    onEnableDevices,
    onReactiveEnableDevice,
    onRetryOrder,
    onRegisterContact,
};

async function getSubscriptionsContact() {
    try {
        let id = httpUtil.getSession().sub;
        const response = await get({
            resourcePath: '/subscriptions',
            queryParams: {
                contact_id: id,
            }
        })
        return response;
    } catch (ex) {
        console.log("getSubscriptionsContact exception===", ex);
        return ex;
    }
}

async function getContactService(service_id, quantity) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await get({
            resourcePath: '/services',
            queryParams: {
                contact_id: id,
                service_id: service_id,
                quantity_device: quantity,
            }
        })
        return response;
    } catch (ex) {
        console.log("getContactService exception===", ex);
        return ex;
    }
}

async function getDevicesSerialNumber(serial_number) {
    try {
        const response = await get({
            resourcePath: '/devices',
            queryParams: {
                serial_number: serial_number,
            }
        })
        return response;
    } catch (ex) {
        console.log("getDevicesSerialNumber exception===", ex);
        return ex;
    }
}

async function onAddDevice({
    serial_number,
    subscription_id = null,
    postal_code,
    town_city,
    state_province_country,
    device_id,
}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/add_device',
            body: {
                contact_id: id,
                subscription_id: subscription_id,
                device_id: device_id,
                serial_number: serial_number,
                address: {
                    postal_code: postal_code,
                    town_city: town_city,
                    state_province_country: state_province_country,
                }
            }
        })
        return response;
    } catch (ex) {
        console.log("onAddDevice exception===", ex);
        return ex;
    }
}

async function onReAuth({
    serial_number,
    code,
    integration_id,
}) {
    try {
        const response = await post({
            resourcePath: '/reauthorisation',
            body: {
                external_reference: serial_number,
                code: code,
                integration_id: integration_id,
            }
        })
        return response;
    } catch (ex) {
        console.log("onReAuth exception===", ex);
        return ex;
    }
}

async function onCancelSubscription(subscription_id) {
    try {
        const response = await put({
            resourcePath: '/subscriptions/' + subscription_id,
        })
        return response;
    } catch (ex) {
        console.log("onCancelSubscription exception===", ex);
        return ex;
    }
}

async function onGetCustomers({email_address, phone_number, register_type}) {
    try {
        const response = await get({
            resourcePath: '/customers',
            queryParams: {
                email_address: email_address,
                phone_number: phone_number,
                register_type: register_type,
            }
        })
        return response;
    } catch (ex) {
        console.log("onCancelSubscription exception===", ex);
        return ex;
    }
}

async function onMergeContact(old_contact_id) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/merge_contact',
            body: {
                current_contact_id: id,
                old_contact_id: old_contact_id,
            }
        })
        return response;
    } catch (ex) {
        console.log("onMergeContact exception===", ex);
        return ex;
    }
}

async function onAddDeivce({
    old_contact_id, 
    device_id, 
    device_product_id
}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = post({
            resourcePath: '/devices',
            body: {
                current_contact_id: id,
                old_contact_id: old_contact_id,
                device_id: device_id,
                device_product_id: device_product_id,
            }
        })
        return response;
    } catch (ex) {
        console.log("onAddDeivce exception===", ex);
        return ex;
    }
}

async function onGetDevices(product_id) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await get({
            resourcePath: '/available_devices',
            queryParams: {
                contact_id: id,
                product_id: product_id,
            }
        })
        return response;
    } catch (ex) {
        console.log("onGetDevices exception===", ex);
        return ex;
    }
}

async function onMakeOrder({
    account_id,
    payment_method_type, 
    services, 
    fulfilled_by,
    supply_method,
}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/make_order',
            body: {
                account_id: account_id,
                payment_method_type: payment_method_type,
                services: services,
                contact_id: id,
                fulfilled_by: fulfilled_by,
                supply_method: supply_method,
            }
        })
        return response;
    } catch (ex) {
        console.log("onMakeOrder exception===", ex);
        return ex;
    }
}

async function onDeactiveService(service_id, device_id, sub_id) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/deactivate_service',
            body: {
                contact_id: id,
                service_id: service_id,
                device_id: device_id,
                subscription_id: sub_id,
            }
        })
        return response;
    } catch (ex) {
        console.log("onDeactiveService exception===", ex);
        return ex;
    }
}

async function requestOTP(contactId) {
    try {
        // let id = httpUtil.getSession().sub;
        const response = await get({
            resourcePath: '/request_otp',
            queryParams: {
                contact_id: contactId,
            }
        })
        return response;
    } catch (ex) {
        console.log("requestOTP exception===", ex);
        return ex;
    }
}

async function verifyOTP({
    otp_value,
    contact_id,
}) {
    try {
        // let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/verify_otp',
            body: {
                otp_value,
                contact_id,
            }
        })
        return response;
    } catch (ex) {
        console.log("verifyOTP exception===", ex);
        return ex;
    }
}

async function onEnableDevice({
    product_id,
    price_term_id,
}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/enable_device',
            body: {
                contact_id: id,
                product_id: product_id,
                price_term_id: price_term_id,
            }
        })
        return response;
    } catch (ex) {
        console.log("onEnableDevice exception===", ex);
        return ex;
    }
}

async function onReactiveEnableDevice({
    service_id,
    device_id,
}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/reactivate/enable_device',
            body: {
                contact_id: id,
                service_id: service_id,
                device_id: device_id,
            }
        })
        return response;
    } catch (ex) {
        console.log("onReactiveEnableDevice exception===", ex);
        return ex;
    }
}

async function onEnableDevices(services) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/enable_devices',
            body: {
                contact_id: id,
                services: services,
            }
        })
        return response;
    } catch (ex) {
        console.log("onEnableDevices exception===", ex);
        return ex;
    }
}

async function getSubscriptionAction(id) {
    try {
        const response = await get({
            resourcePath: '/subscription_action/' + id,
        })
        return response;
    } catch (ex) {
        console.log("getSubscriptionAction exception===", ex);
        return ex;
    }
}

async function initPayment({
    email_address,
    contact_code,
    amount,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/payment_gateways/init_payment',
            body: {
                contact_id: id,
                email_address: email_address,
                contact_code: contact_code,
                amount: amount,
            },
            isPaygate: true,
        });
        return response;
    } catch (ex) {
        return ex;
    }
}

async function createPayment({
    payment_request_id,
    amount,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/payment_gateways/create_payment',
            body: {
                contact_id: id,
                code: payment_request_id,
                amount: amount,
            },
            isPaygate: true,
        });
        return response;
    } catch (ex) {
        return ex;
    }
}

async function onUpdateDeviceName({
    device_id,
    device_name,
}) {
    try {
        const response = await post({
            resourcePath: '/devices/update_name',
            body: {
                device_id: device_id,
                device_name: device_name,
            }
        })
        return response;
    } catch (ex) {
        console.log("onUpdateDeviceName exception===", ex);
        return ex;
    }
}

async function onEstimateOrder({
    services,
}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/estimate_order',
            body: {
                contact_id: id,
                services: services,
            }
        })
        return response;
    } catch (ex) {
        console.log("onEstimateOrder exception===", ex);
        return ex;
    }
}

async function onRetryOrder({
    account_id,
    payment_method_type, 
    services, 
    fulfilled_by,
    supply_method,
}) {
    try {
        let id = httpUtil.getSession().sub;
        const response = await post({
            resourcePath: '/retry_order',
            body: {
                account_id: account_id,
                payment_method_type: payment_method_type,
                services: services,
                contact_id: id,
                fulfilled_by: fulfilled_by,
                supply_method: supply_method,
            }
        });
        return response;
    } catch (ex) {
        console.log("AAAA onRetryOrder exception===", ex);
        return ex;
    }
}

async function onRegisterContact({
    first_name,
    last_name,
    email_address,
    phone_number,
    country_code,
    provider,
}) {
    try {
        const response = await post({
            resourcePath: '/register_contact',
            body: {
                first_name,
                last_name,
                email_address,
                phone_number,
                country_code,
                provider,
            }
        })
        return response;
    } catch (ex) {
        console.log("onRegisterContact exception===", ex);
        return ex;
    }
}

function createOption(isPaygate) {
    var options = {};
    options.headers = {
        'User-Agent': 'request',
        'Content-Type': 'application/json; charset=utf-8',
        'api_key': isPaygate ? apiKeyPaygate : api_key,
    };
    return options;
}

function cleanObj(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
}

function json2Obj(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}

function getURI(resourcePath, isPaygate) {
    if(isPaygate) return urlPaygate + resourcePath;
    else return urlPlugins + resourcePath;
}

async function get({
    resourcePath,
    queryParams
}) {
    try {
        var options = createOption();
        options.method = 'GET';
        let uri = getURI(resourcePath);
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));;
        console.log("GET uri:", uri);
        console.log("GET options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("AAAA e:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function post({
    resourcePath,
    body,
    isPaygate
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'POST';
        let uri = getURI(resourcePath, isPaygate);
        if (body)
            options.body = JSON.stringify(body);
        console.log("GET uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("post exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function put({
    resourcePath,
    body,
}) {
    try {
        var options = createOption();
        options.method = 'PUT';
        let uri = getURI(resourcePath);
        if (body)
            options.body = JSON.stringify(body);
        console.log("GET uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("put exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}


